import { render, staticRenderFns } from "./Cave3DModelTooltip.vue?vue&type=template&id=3842074b&scoped=true"
import script from "./Cave3DModelTooltip.vue?vue&type=script&lang=js"
export * from "./Cave3DModelTooltip.vue?vue&type=script&lang=js"
import style0 from "./Cave3DModelTooltip.vue?vue&type=style&index=0&id=3842074b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842074b",
  null
  
)

export default component.exports